import { ApplicationTypes, attachAdminComponent } from 'jms-domain'

import { createAdminPages } from '@salsita-ai/platform-project-sdk/admin'
import {
  memoEval,
  navigationPageComponent,
  navigationPanelListComponent,
} from '@salsita-ai/platform-project-sdk/domain'

import { ProductImportButton } from '../../pages/admin/ProductImportButton'
import { ProductPage } from '../../pages/admin/Products'

const { commonComponents, commonPages } = createAdminPages({})

export { commonComponents }

export const adminComponents = [
  attachAdminComponent
    .withEntity('Admin')
    .withComponent(navigationPageComponent, 'products')
    .withFilter({
      navigationStates: [ApplicationTypes.AdminNavigationState.Products],
    })
    .attach(
      memoEval(
        () => [],
        () => {
          return {
            title: 'Products',
            breadcrumbs: [],
            content: <ProductPage />,
            actions: <ProductImportButton />,
          }
        }
      )
    ),

  attachAdminComponent
    .withEntity('Admin')
    .withComponent(navigationPanelListComponent, 'main')
    .attach(
      memoEval(
        () => [],
        () => {
          return {
            items: [
              ...commonPages,
              {
                label: 'Products',
                icon: 'TagBold',
                navigationStates: [ApplicationTypes.AdminNavigationState.Products],
              },
            ],
          }
        }
      )
    ),
]
